<template>
  <span>
    <!-- 详情页顶部标题上方编号右侧 -->
    <i
      v-if="'detail' == dataMode"
      @click="shareTicket"
      title="点击复制工单标题和链接[7]"
      style="cursor:pointer;font-size:20px;padding-left:10px;"
      class="el-icon-share hover_0"
    ></i>

    <!-- 视图页工单列表 和 工单标题浮窗 -->
    <i
      v-else
      @click="shareTicket"
      title="点击复制工单标题和链接[16]"
      style="cursor:pointer;font-size:15px;"
      class="el-icon-share hover_0"
    ></i>
  </span>
</template>

<script>
export default {
  name: "TicketShare",

  props: ['ticket', 'ticketNo', 'mode'],

  data() {
    return {
      dataMode : null,
      ticketEntity : null
    };
  },

  methods: {
    shareTicket() { // 将标题和链接写入剪贴板,供粘贴分享
      var _this = this;

      if ( !!_this.ticket && !!_this.ticket.orderId ) {
        _this.shareTicket_0();
        return;
      }

      // 没有工单对象 只有ID 查询工单
      sdk.TicketApi().findByOrderId({
        orderId : _this.ticketNo
      }).then(res => {
        _this.ticketEntity = res;

        _this.shareTicket_0();
      });
    },

    // 将标题和链接写入剪贴板,供粘贴分享
    shareTicket_0() {
      var _title = !!this.ticketEntity ? this.ticketEntity.orderTitle : this.ticket.orderTitle ;
      var _orderId = !!this.ticketEntity ? this.ticketEntity.orderId : this.ticket.orderId;

      if ( !_title ) {
        _title = "工单 " + _orderId;
      }

      var _url = "http://" + window.location.host + "/ticket/t/" + _orderId;

      this.writeToClipboard(_title + " " + _url);

      _message("当前工单标题和链接 已复制到剪贴板");
    },

    loadMode() {
      if ( !!this.mode ) {
        this.dataMode = this.mode;
        return;
      }

      // 详情模式
      if ( "/ticket-vue/ticket/detail" == this.$route.path ) {
        this.dataMode = "detail";
        return;
      }

      // 列表模式
      if ( "/ticket-vue/ticket/view" == this.$route.path ) {
        this.dataMode = "view";
        return;
      }
    }
  },

  mounted() {
    this.loadMode();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketShare.vue